import { StepComponentProps } from '../../Siniestros'
import { AccidenteTransitoDetalle } from './AccidenteTransitoDetalle';
import { AccidenteTransitoTerceros } from './AccidenteTransitoTerceros';
import './styles.css';


export const AccidenteTransito = ({ setSteps, config, substep }: StepComponentProps) => {

    const renderVista = () => {
        switch (substep) {
            case 0:
                return <AccidenteTransitoDetalle setSteps={setSteps} config={config}/>
            case 1:
                return <AccidenteTransitoTerceros setSteps={setSteps} config={config}/>
            default: return <div>Error: Paso no encontrado</div>;
        }
    };

    return (
        <>
            {renderVista()}
        </>
    )
}
